import React from "react";

import { useSearchParams } from "routes/hooks";
import { Header, MenuItem, Tab } from "semantic-ui-react";

import useCurrentUser from "data/advisor/useCurrentUser";
import useHub from "data/hub/useHub";

import { useFeatures } from "components/FeatureFlag";

import {
  HubIntegrationSettings,
  ImportedMeetingTypesTable,
  ImportedStatusTable,
} from "./components";

function IntegrationSettings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useCurrentUser();
  const hub = useHub();
  const importContactsFF = useFeatures("crm-contact-import-by-status");

  const tabsMap = {
    hub: 0,
    contacts: 1,
    meetings: 2,
  };

  const userIntegrations = user.integrations.reduce(
    (result, { type }) => {
      return {
        hasIntegration: true,
        redtail: result.redtail || type === "redtail",
        salesforce: result.salesforce || type === "salesforce",
        wealthbox: result.wealthbox || type === "wealthbox",
      };
    },
    {
      hasIntegration: false,
      redtail: false,
      salesforce: false,
      wealthbox: false,
    }
  );

  const panes = [
    {
      menuItem: (
        <MenuItem data-test="integration-settings-hub-tab">Hub</MenuItem>
      ),
      render: () => {
        return <HubIntegrationSettings userIntegrations={userIntegrations} />;
      },
    },
    importContactsFF &&
    (userIntegrations.redtail || userIntegrations.salesforce)
      ? {
          menuItem: (
            <MenuItem data-test="integration-settings-contacts-tab">
              Contacts
            </MenuItem>
          ),
          render: () => {
            return <ImportedStatusTable />;
          },
        }
      : {},
    hub?.preferences?.sync?.shouldSyncMeetings
      ? {
          menuItem: (
            <MenuItem data-test="integration-settings-meetings-tab">
              Meetings
            </MenuItem>
          ),
          render: () => {
            return <ImportedMeetingTypesTable />;
          },
        }
      : {},
  ];

  if (userIntegrations.hasIntegration) {
    return (
      <div
        data-test="integration-settings"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Header as="h1">Integration Settings</Header>

        <Tab
          menu={{ secondary: true, pointing: true }}
          panes={panes}
          activeIndex={tabsMap[searchParams?.tab] || tabsMap.hub}
          onTabChange={(e, { activeIndex }) => {
            setSearchParams({ tab: Object.keys(tabsMap)[activeIndex] });
          }}
        />
      </div>
    );
  }

  return null;
}

export default IntegrationSettings;
